/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsLogoList = {
  init: function($section) {

    // Add settings from schema to current object
    window.PXUTheme.jsLogoList = $.extend(this, window.PXUTheme.getSectionData($section));

    this.createSlider();

  },
  createSlider: function() {

    let logoListSlider = $('.logo-list .slider');

    $(logoListSlider).flickity({
      lazyLoad: 2,
      freeScroll: true,
      imagesLoaded: true,
      draggable: true,
      cellAlign: 'center',
      wrapAround: true,
      pageDots: false,
      contain: false,
      prevNextButtons: false,
      autoPlay: 1500,
      initialIndex: 0,
      watchCSS: true,
      on: {
        ready: function() {
          // Resize flickity when the slider is settled
          $(logoListSlider).on( 'settle.flickity', function() {
            $(logoListSlider).flickity('resize')
          });
        }
      }
    });

  },
  unload: function($section) {
    let $slider = $section.find('.flickity-enabled');
    $slider.flickity('destroy');
  }
}

/******/ })()
;